import { DashboardInterval } from '@business/entities/dashboard';
import { WidgetType } from '@modules/dashboards/Widgets';

export function getAllWidgets() {
  return [
    WidgetType.stat,
    WidgetType.statWithChart,
    WidgetType.timeline,
    WidgetType.text,
    WidgetType.linechart,
    WidgetType.progressCircle,
    WidgetType.pieChart,
    WidgetType.barChart,
    WidgetType.statExpanded,
    WidgetType.list,
    WidgetType.funnel,
    WidgetType.sectionTitle,
  ];
}

export function getWidgetTitle(widget: WidgetType) {
  switch (widget) {
    case WidgetType.stat:
      return 'Stats';
    case WidgetType.timeline:
      return 'Timeline';
    case WidgetType.text:
      return 'Text Area';
    case WidgetType.linechart:
      return 'Line Chart';
    case WidgetType.progressCircle:
      return 'Progress Circle';
    case WidgetType.pieChart:
      return 'Pie Chart';
    case WidgetType.statWithChart:
      return 'Stat with Charts';
    case WidgetType.barChart:
      return 'Bar Chart';
    case WidgetType.statExpanded:
      return 'Stat Expanded';
    case WidgetType.list:
      return 'List';
    case WidgetType.funnel:
      return 'Funnel';
    case WidgetType.sectionTitle:
      return 'Section Title';
    case WidgetType.graph:
      return 'Graph';
  }
}

export function getFrequencyTitle(frequency: DashboardInterval) {
  switch (frequency) {
    case DashboardInterval.daily:
      return 'Yesterday';
    case DashboardInterval.weekly:
      return 'This Week';
    case DashboardInterval.monthly:
      return 'This Month';
    case DashboardInterval.yearly:
      return 'This Year';
    case DashboardInterval.sameAsDashboard:
      return 'Same as Dashboard';
    case DashboardInterval.custom:
      return 'Date Range';
  }
  return frequency;
}

export function frequencies(asDashboard = false, hasCustom = false) {
  const items = [DashboardInterval.daily, DashboardInterval.weekly, DashboardInterval.monthly, DashboardInterval.yearly];
  if (asDashboard) {
    items.unshift(DashboardInterval.sameAsDashboard);
  }
  if (hasCustom) {
    items.push(DashboardInterval.custom);
  }
  return items;
}
